import create from './simpleCrudServiceFactory';
export default create('api/roles');
